import React from 'react';

interface Rule {
  id: number;
  title: string;
  description: string;
  severity: 'low' | 'medium' | 'high';
}

interface ServerRulesProps {
  rules: Rule[];
  className?: string;
}

const ServerRules: React.FC<ServerRulesProps> = ({ 
  rules,
  className = ''
}) => {
  if (!rules || rules.length === 0) {
    return null;
  }

  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case 'high': return 'text-red-400';
      case 'medium': return 'text-yellow-400';
      case 'low': return 'text-green-400';
      default: return 'text-gray-400';
    }
  };

  return (
    <div className={`bg-gray-800 rounded-lg shadow-lg p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">Server Rules</h3>
      
      <div className="space-y-4">
        {rules.map(rule => (
          <div key={rule.id} className="border-l-4 border-gray-700 pl-4 py-2">
            <div className="flex justify-between items-start">
              <h4 className="font-bold">{rule.title}</h4>
              <span className={`text-sm font-medium ${getSeverityColor(rule.severity)}`}>
                {rule.severity.charAt(0).toUpperCase() + rule.severity.slice(1)}
              </span>
            </div>
            <p className="text-gray-400 mt-1">{rule.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServerRules;